module.exports = __webpack_public_path__ + "img/shade_star.d3dd3fd2.jpg";